import { useEffect, useState } from 'react';

/** Delays Fade `in` by one frame so MUI Modal open + Fade enter animate together. */
const useFadeOpen = (open: boolean) => {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    if (!open) {
      setShowContent(false);
      return undefined;
    }

    const frameId = requestAnimationFrame(() => {
      setShowContent(true);
    });

    return () => cancelAnimationFrame(frameId);
  }, [open]);

  return showContent;
};

export default useFadeOpen;
